import { TypeInitProps, TypeRequest } from '../../../types';
import { WEB_AFF_URL } from '../../../utils/urls';
export default class RoleAPI {
  private request: any;
  constructor(props: TypeInitProps & { request: TypeRequest }) {
    const { request } = props;
    this.request = request;
  }

  /**
   * @param {string} role_name - name
   * @param {string} permissions - concatenation of resources permissions
   * @param {number} subject_uid - id of subject
   * @return {Promise} create result
   */
  createRole = (params: {
    role_name: string;
    permissions: string;
    subject_uid: number;
    extra_params?: object;
  }) => {
    const { role_name, permissions, subject_uid, extra_params = {} } = params;
    return new Promise((resolve, reject) => {
      this.request({
        url: WEB_AFF_URL.CREATE_ROLE,
        method: 'POST',
        data: {
          role_name,
          permissions,
          subject_uid,
          ...extra_params,
        },
      })
        .then((data: any) => {
          resolve(data);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  };

  /**
   * @param {string} role_key - id of role
   * @param {string} role_name - name
   * @param {string} permissions - concatenation of resources permissions
   * @param {string} description - description
   * @param {number} subject_uid - id of subject
   * @return {Promise} update result
   */
  updateRole = (params: {
    role_key: string;
    role_name?: string;
    permissions?: string;
    description?: string;
    subject_uid: number;
    extra_params?: object;
  }) => {
    const {
      role_key,
      role_name,
      permissions,
      description,
      subject_uid,
      extra_params = {},
    } = params;
    return new Promise((resolve, reject) => {
      this.request({
        url: WEB_AFF_URL.UPDATE_ROLE,
        method: 'POST',
        data: {
          role_key,
          role_name,
          permissions,
          description,
          subject_uid,
          ...extra_params,
        },
      })
        .then((data: any) => {
          resolve(data);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  };

  /**
   * @param {string} role_key - id of role
   * @param {number} subject_uid - id of subject
   * @return {Promise} ban result
   */
  banRole = (params: {
    role_key: string;
    subject_uid: number;
    extra_params?: object;
  }) => {
    const { role_key, subject_uid, extra_params = {} } = params;
    return new Promise((resolve, reject) => {
      this.request({
        url: WEB_AFF_URL.BAN_ROLE,
        method: 'POST',
        data: {
          role_key,
          subject_uid,
          ...extra_params,
        },
      })
        .then((data: any) => {
          resolve(data);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  };

  /**
   * @param {number} subject_uid - id of subject
   * @return {Promise} request result
   */
  getRoleList = (params: { subject_uid: number; extra_params?: object }) => {
    const { subject_uid, extra_params = {} } = params;
    return new Promise((resolve, reject) => {
      this.request({
        url: WEB_AFF_URL.ROLE_LIST,
        method: 'GET',
        data: {
          subject_uid,
          ...extra_params,
        },
      })
        .then((data: any) => {
          resolve(data);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  };

  /**
   * @param {string} role_key - id of role
   * @param {number} subject_uid - id of subject
   * @return {Promise} request result
   */
  getRoleInfo = (params: {
    role_key: string;
    subject_uid: number;
    extra_params?: object;
  }) => {
    const { role_key, subject_uid, extra_params = {} } = params;
    return new Promise((resolve, reject) => {
      this.request({
        url: WEB_AFF_URL.ROLE_INFO,
        method: 'GET',
        data: {
          role_key,
          subject_uid,
          ...extra_params,
        },
      })
        .then((data: any) => {
          resolve(data);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  };
}
